module.exports = __webpack_public_path__ + "img/shuffle.6edbbcaf.svg";